import React from 'react';

import { SECTIONS, COMPONENTS } from 'components/Globals/Analytics/constants';
import SectionBlock from 'components/Globals/SectionBlock';
import ProductionListView from 'components/Productions/Common/ProductionListView';
import { useSeasonFilters } from 'components/Productions/Display/Seasons';

import { ENTITY_MAIN_TABS, TP } from 'constants/index';

import usePageContext from 'utils/hooks/usePageContext';

import { useTranslation } from 'src/i18n';

import classes from './EntityUpcomingPerformances.module.scss';

const upcomingPerformanceTrackingDataSection = {
  section: SECTIONS.UPCOMING_PERFORMANCES,
};

const seeAllUpcomingPerformanceTrackingData = {
  ...upcomingPerformanceTrackingDataSection,
  component: COMPONENTS.SEE_ALL_CTA,
};
const upcomingPerformanceTrackingDataSlug = {
  ...upcomingPerformanceTrackingDataSection,
  component: COMPONENTS.PRODUCTION_SLUG,
};

const EntityUpcomingPerformances = ({ entity, entityType, sectionProps = {}, showFilters = false }) => {
  const { t } = useTranslation('NS_ENTITY_STUB_PAGE');
  const { navigate } = usePageContext();
  const baseFilters = useSeasonFilters({ isUpcoming: true });

  const linkProps = navigate.getLinkProps({ entity, entityType, path: ENTITY_MAIN_TABS.PERFORMANCES });

  return (
    <SectionBlock
      title={t(`${TP}.FN_UPCOMING_PERFORMANCES`)}
      linkProps={{
        ...linkProps,
        title: t('VIEW_ALL_CTA', { title: t(`${TP}.FN_UPCOMING_PERFORMANCES`) }),
      }}
      seeAllTrackingData={seeAllUpcomingPerformanceTrackingData}
      {...sectionProps}
      styles={{ seeAllButton: classes.seeAllButton, leftBoxIcon: classes.leftBoxIcon }}
      enableSeeAll={false}
      enableViewAllButton={false}
    >
      <div className={classes.root}>
        <ProductionListView
          overrideFilters={baseFilters}
          limit={12}
          showFilters={showFilters}
          trackingData={upcomingPerformanceTrackingDataSlug}
          infinite
          showSortOptions
        />
      </div>
    </SectionBlock>
  );
};

export default EntityUpcomingPerformances;
